import { fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query'
import { RootState } from '@/redux/store.ts'
import { handleSessionExpiredError } from '@/utils/api.tsx'

type AppBaseQueryOptions = {
  baseUrl?: string
}

export const appPortalBaseQuery = (option?: AppBaseQueryOptions): BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError,
  {},
  FetchBaseQueryMeta
> => {
  const baseQuery = fetchBaseQuery({
    baseUrl: option?.baseUrl || import.meta.env.VITE_FINANCE_PORTAL_API_BASE_URL,
    credentials: 'include',
    redirect: 'manual',
    prepareHeaders: (headers, { getState, endpoint }) => {
      // Use the token if it's in the store
      const state = getState() as RootState
      const user = state.auth.user

      const token = user?.token ?? ''
      if (token && !(['login', 'impersonateUser'].includes(endpoint))) {
        headers.set('Authorization', `Bearer ${token}`)
      }

      return headers
    },
  })

  return async (args, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions as {})
    // Handle 302 redirect
    if (
      result.meta?.response?.status === 0 &&
      result.meta?.response?.type === 'opaqueredirect'
    ) {
      result.error = {
        status: 302,
        data: null,
      }
    }
    handleSessionExpiredError(result)

    return result
  }
}
